/*
 * Monogram personalization control for the product form.
 *
 * Why a custom element: the inputs must NOT contribute line-item properties
 * unless the shopper explicitly opts in, and the text field is only required
 * while the panel is open. We enforce both by disabling the inputs while the
 * <details> is collapsed (disabled controls are never submitted) and toggling
 * `required` with the open state.
 */
if (!customElements.get('monogram-personalizer')) {
  customElements.define(
    'monogram-personalizer',
    class MonogramPersonalizer extends HTMLElement {
      connectedCallback() {
        this.textInput = this.querySelector('[data-monogram-input]');
        this.fontInputs = this.querySelectorAll('[data-monogram-font]');

        if (!this.textInput) return;

        this.onInput = this.onInput.bind(this);
        this.onFontChange = this.onFontChange.bind(this);
        this.onFormData = this.onFormData.bind(this);

        this.textInput.addEventListener('input', this.onInput);
        this.fontInputs.forEach((input) => input.addEventListener('change', this.onFontChange));

        this.form = this.textInput.form;
        this.form && this.form.addEventListener('formdata', this.onFormData);

        this.previewFont();
      }

      disconnectedCallback() {
        this.textInput && this.textInput.removeEventListener('input', this.onInput);
        this.fontInputs.forEach((input) => input.removeEventListener('change', this.onFontChange));
        this.form && this.form.removeEventListener('formdata', this.onFormData);
      }

      onInput() {
        // Monograms are uppercase letters only (mirrors the legacy behavior).
        const cleaned = this.textInput.value.toUpperCase().replace(/[^A-Z]/g, '');
        if (cleaned !== this.textInput.value) this.textInput.value = cleaned;
      }

      onFontChange() {
        this.previewFont();
      }

      onFormData(event) {
        if (this.textInput.value.trim() !== '') return;
        event.formData.delete(this.textInput.name);
        this.fontInputs.length && event.formData.delete(this.fontInputs[0].name);
      }

      // Mirror the chosen font onto the text field so typed characters preview
      // in it. The class handle must match Liquid's `| handle` filter.
      previewFont() {
        const selected = Array.from(this.fontInputs).find((input) => input.checked);
        this.textInput.classList.forEach((cls) => {
          if (cls.indexOf('mono-font-') === 0) this.textInput.classList.remove(cls);
        });
        if (!selected) return;
        const handle = selected.value
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
        if (handle && handle !== 'none') this.textInput.classList.add('mono-font-' + handle);
      }
    }
  );
}
